export const HOME_BODY_COLOR = "#fbfbfb";
export const HEART_COLOR = "#C0392B";
export const ARROW_COLOR = "#117A65";
export const VARIABLE_TAG_BACKGROUND = "#fce6df";
